import axios from 'axios';
import config from '../../config';
import * as types from './actionTypes';

export const actionCreators = {
  requestPortalSettings: (accountUniqueName) => async (dispatch) => {
    try {
      const response = await axios.get(
        `${config.apiUrl}/api/account-details/${accountUniqueName}/theme`
      );
      const settings = response.data;
      dispatch({ type: types.getPortalSettingsSuccess, settings });

    } catch (error) {
      dispatch({
        type: types.staticDataApiRequestError,
        error: error.response
          ? error.response.data
          : "Failed to retrieve theme.",
      });
    }
    
    // TODO: check when to use it with Marlon
    //failed to retrieve settings - resolve to fallback
    //dispatch({ type: types.getPortalSettingsFallback });
  },
  requestConfigurationSettings: (accountUniqueName) => async (dispatch) => {
    try {
      const response = await axios.get(
        `${config.apiUrl}/api/account-details/${accountUniqueName}/configuration-settings`
      );
      const settings = response.data;

      dispatch({ type: types.getConfigurationSettingsSuccess, settings });
      return settings;
    } catch (error) {
      dispatch({
        type: types.staticDataApiRequestError,
        error: error.response
          ? error.response.data
          : "Failed to retrieve configuration settings.",
      });
    }
  },
  requestCountries: () => async (dispatch, getState) => {
    if (getState().staticData.countries.length) {
      return;
    }

    dispatch({ type: types.getCountries });

    try {
      const response = await axios.get(
        `${config.apiUrl}/api/static-data/countries`
      );

      const countries = response.data;

      dispatch({ type: types.getCountriesSuccess, countries });
    } catch (error) {
      dispatch({
        type: types.staticDataApiRequestError,
        error: error.response
          ? error.response.data
          : "Failed to retrieve countries.",
      });
    }
  },
  requestNationalities: () => async (dispatch, getState) => {
    if (getState().staticData.nationalities.length) {
      return;
    }
    
    dispatch({ type: types.getNationalities });
    
    try {
      const response = await axios.get(
        `${config.apiUrl}/api/static-data/nationalities`
        );
        
        const nationalities = response.data;
        
      dispatch({ type: types.getNationalitiesSuccess, nationalities });
      } catch (error) {
        dispatch({
          type: types.staticDataApiRequestError,
          error: error.response
          ? error.response.data
          : "Failed to retrieve nationalities.",
        });
      }
    },
    requestDocumentSettings: () => async (dispatch, getState) => {
      if (getState().staticData.documentSettings) {
        return;
      }
      dispatch({ type: types.getDocumentSettings });
      try {
        const response = await axios.get(
        `${config.apiUrl}/api/static-data/documents/settings`
        );
        dispatch({ type: types.getDocumentSettingsSuccess, documentSettings: response.data });
    } catch (error) {
      dispatch({
        type: types.staticDataApiRequestError,
        error: error.response
          ? error.response.data
          : "Failed to retrieve document settings.",
      });
    }
  },
};
